module.exports = __webpack_public_path__ + "img/option_icon.1d76a8eb.svg";